import React, { Component } from "react";
import "./SetWarrantyDetails.css";
import "../../../common.css";
import Modal from "react-modal";
import config from "../../../../config";
import { icons } from "../../../../img/icons";
import logo from "../../../../img/logo_32.png";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import LoadingPage from "../../../../components/Loading/Loading";
import errorFunctions from "../../../../store/errorFunctions";
import utilityFunctions from "../../../../store/utilityFunctions";
Modal.setAppElement("body");

const COMMERCIAL_ROLES = ["Commercial Admin", "Commercial Staff"];
export default class SetWarrantyDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reason: [],
      modelType: "", // Default to top item in options list (shortcut work)
      userInfo:
        localStorage.getItem("userInfo") ||
        utilityFunctions.getCookie("userInfo"),
    };
  }

  handleCheckboxChange = (e) => {
    const { name, value, checked } = e.target;
    let values = this.state[name],
      valueExists = values.indexOf(value);

    if (checked) {
      // Add if doesn't exist
      if (valueExists === -1) {
        values.push(value);
      }
    } else {
      // Remove if does exist
      if (valueExists > -1) {
        values.splice(valueExists, 1);
      }
    }

    this.setState({ [name]: values });
  };
  handleInputChange = (e) => {
    const { id, value } = e.target;

    this.setState({
      [id]: value,
    });
  };
  handleSubmit = (e) => {
    this.setState({ submitProgress: true });
    e.preventDefault();

    // const mediaFile = document.getElementById("uploadFile").files[0] || null;
    let formData = new FormData();
    formData.append("reason", this.state.reason);
    formData.append("ticket_type", this.state.ticketType || "warranty");
    formData.append("service", this.state.type_of_service);
    formData.append("system_error", this.state.systemError);
    formData.append("user_device", parseInt(this.props.userDevice) || 0);
    formData.append("other_issue", this.state.otherIssue);
    formData.append("brand_id", this.props.selectedbrandID);
    // mediaFile && formData.append("media", mediaFile);
    if (this.state.problemFiles?.length > 0) {
      this.state.problemFiles.forEach((file) => formData.append("media", file));
    }
    formData.append("customer", this.props.customerId);

    this.props
      .protectedFetch(
        config.backendServer + "ticket/new/",
        "POST",
        formData,
        errorFunctions.checkResponseThenJson,
        true
      )
      .then((res) => {
        const { handleRefresh, retrieveCustomerDevices, isRegisterDevice } =
          this.props;
        const { userInfo } = this.state;

        const userRole = JSON.parse(userInfo).user?.role;
        const isCommercialRole = COMMERCIAL_ROLES.includes(userRole);

        if (!isCommercialRole) {
          alert("Success add ticket");
        }

        if (this.props.handleSuccess) {
          this.props.handleSuccess();
        } else this.props.hideModal();

        handleRefresh?.();
        retrieveCustomerDevices?.();

        this.setState({ submitProgress: false });

        if (isCommercialRole || isRegisterDevice) {
          this.handleChangeTicketLocation(res.id);
        }
      })
      .catch((e) => {
        console.log("Fail", e);
        this.setState({ submitProgress: false });
      });
  };

  handleChangeTicketLocation = (ticketId) => {
    this.setState({ loading: true });

    let payload = {
      store_location: JSON.parse(this.state.userInfo).user?.store_location_id,
    };

    this.props
      .protectedFetch(
        config.backendServer + `ticket/${ticketId}/change-location/`,
        "PATCH",
        payload,
        errorFunctions.checkResponseThenJson
      )
      .then(() => {
        alert("Success add ticket");
        if (this.props.retrieveWarranty) {
          this.props.retrieveWarranty();
        }

        if (this.props.handleCloseModal) {
          this.props.handleCloseModal();
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log("fail", err);
        this.setState({ loading: false });
      });
  };
  
  handleFileUpload = (e) => {
    const newFiles = Array.prototype.slice.call(e.target.files);
    let allFiles = this.state.problemFiles
      ? [...this.state.problemFiles, ...newFiles]
      : [...newFiles];
    if (allFiles.length > 5) {
      alert("Maximum file to be uploaded is only 5");
      allFiles = allFiles.slice(0, 5);
    }
    this.setState({ problemFiles: allFiles });
  };

  render() {
    const ticketTypes = [
      {
        value: "warranty",
        label: "Warranty or Service Claims (within 1 - 2 years)",
      },
      { value: "out_of_warranty", label: "Service (Out of Warranty)" },
    ];
    const checkboxes = [
      "No suction",
      "Leaking water from base station",
      "Dust bag installation error",
      "Recharge failed",
      "Spins in circles",
      "Tilts or unstable movement",
      "Side brush not working",
      "Red light flashing",
      "White light flashing",
      "Rag tray keeps falling off",
      "Map overlay distorted navigation",
      "Can't connect to WiFi / App / Bluetooth",
      "Laser sensor issue",
      "Wheel error or stuck wheels",
      "No sewage absorption",
      "Abnormal water level in cleaning tray",
      "Driving wheel oil leakage",
      "Abnormal battery reading",
      "Main brush error",
      "Filter error",
      "Sewage tank not detected",
      "Shuts down after leaving charging dock",
      "Unusual suction noise",
      "Obstacle avoidance not working",
    ];

    return (
      <Modal
        isOpen={this.props.showModal}
        contentLabel={"Set warranty details"}
        className={"set-warranty-modal"}
        style={{
          overlay: { zIndex: 1001 },
        }}
      >
        {/* Bootstrap Modal Start */}
        <div
          className="modal show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ background: "rgba(0,0,0,0.5)", zIndex: 1001 }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            style={{ maxWidth: 800 }}
          >
            <div className="modal-content">
              <div
                className="modal-header flex-column align-items-center border-bottom-2 pb-2"
                style={{ position: "relative" }}
              >
                <img
                  className="NavbarLogo mb-2"
                  src={logo}
                  alt="logo"
                  style={{ height: 15 }}
                />
                <h2 className="pageHeader text-center w-100 mb-0">
                  Warranty Request
                </h2>
                <button
                  type="button"
                  className="btn-close position-absolute end-0 top-0 m-3"
                  aria-label="Close"
                  onClick={this.props.hideModal}
                ></button>
              </div>
              <div
                className="modal-body"
                style={{ height: "80vh", overflowY: "auto" }}
              >
                <div className="page add-new-warranty-page">
                  <div className="pageContent">
                    <form onSubmit={this.handleSubmit}>
                      <div className="form-field">
                        <label>Type of Service*</label>
                        <Select
                          id={"ticketType"}
                          name={"ticketType"}
                          value={this.state.ticketType || ""}
                          onChange={(e) =>
                            this.handleInputChange({
                              target: {
                                id: "ticketType",
                                value: e.target.value,
                              },
                            })
                          }
                          required
                          displayEmpty
                          fullWidth
                          size="small"
                          className="text-left"
                        >
                          <MenuItem
                            className="w-100 text-left"
                            value=""
                            disabled
                          >
                            ---Select service---
                          </MenuItem>
                          {ticketTypes.map((option, j) => (
                            <MenuItem
                              className="w-100 text-left"
                              key={j}
                              value={option.value}
                            >
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                      <div className={"add-new-warranty-special-input-header"}>
                        Please select and provide reason of return below:
                      </div>
                      {checkboxes.map((item, i) => {
                        return (
                          <label
                            className={`add-new-warranty-checkbox-container ${
                              item.length > 50
                                ? "add-new-warranty-checkbox-container-full-width"
                                : ""
                            }`}
                            key={i}
                          >
                            <input
                              type="checkbox"
                              id={"reason" + i}
                              name="reason"
                              value={item}
                              onChange={this.handleCheckboxChange}
                            />
                            <span className={"add-new-warranty-checkbox-text"}>
                              {item}
                            </span>
                          </label>
                        );
                      })}

                      <div className="form-field">
                        <label>Is there a System Error? (Error 1-18)*</label>
                        <input
                          type={"text"}
                          onChange={this.handleInputChange}
                          id={"systemError"}
                          required
                        />
                      </div>
                      <div className={"form-field"}>
                        <label>Other issue, please describe in details*</label>
                        <textarea
                          required
                          onChange={this.handleInputChange}
                          id={"otherIssue"}
                        />
                      </div>
                      <div className={"form-field"}>
                        <div className="d-flex gap-3 justify-content-between">
                          <div>
                            <label
                              htmlFor="uploadProblemFiles"
                              className="custom-file-upload"
                            >
                              <img src={icons.Upload} alt="" /> Choose Files
                            </label>
                            <span>{`  ${
                              this.state.problemFiles ? "" : "No file choosen"
                            }`}</span>
                            <input
                              accept="image/jpeg, image/png, video/mp4, video/webm, video/quicktime"
                              type={"file"}
                              id={"uploadProblemFiles"}
                              multiple
                              // className="custom-file-upload"
                              onChange={this.handleFileUpload}
                            />
                          </div>
                          <div className="mb-2">
                            <strong>Attachments:</strong>
                            <ul className="mb-0">
                              <li>Troubleshooting videos or photos</li>
                              <li>Screenshot of system error</li>
                              <li>Photos of the full unit and issue</li>
                            </ul>
                          </div>
                        </div>

                        {/* <div>Please upload your proof of purchase</div> */}
                      </div>
                      <div className="d-flex flex-row w-100 overflow-auto">
                        {this.state.problemFiles &&
                          this.state.problemFiles.map((file, i) => {
                            if (file.type.includes("image")) {
                              return (
                                <div className="m-2 border " key={i}>
                                  <div className="text-end">
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm m-1 py-0"
                                      onClick={() =>
                                        this.handleRemoveFile(file.name)
                                      }
                                    >
                                      x
                                    </button>
                                  </div>
                                  <img
                                    src={URL.createObjectURL(file)}
                                    title={file.name}
                                    alt=""
                                    height={120}
                                    width={120}
                                  />
                                </div>
                              );
                            } else {
                              return (
                                <div className="m-2 border " key={i}>
                                  <div className="text-end">
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm m-1 py-0"
                                      onClick={() =>
                                        this.handleRemoveFile(file.name)
                                      }
                                    >
                                      x
                                    </button>
                                  </div>
                                  <video
                                    src={URL.createObjectURL(file)}
                                    title={file.name}
                                    height={120}
                                    width={120}
                                  />
                                </div>
                              );
                            }
                          })}
                      </div>
                      {this.state.submitProgress ? (
                        <LoadingPage small={true} />
                      ) : (
                        <button
                          disabled={this.state.submitProgress}
                          className="k-btn k-btn-primary-full"
                          type="submit"
                        >
                          Submit
                        </button>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Bootstrap Modal End */}
      </Modal>
    );
  }
}
